import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzTrendBar } from './sz-trend-bars.types';

@Component({
  selector: 'sz-trend-bars',
  templateUrl: './sz-trend-bars.component.html',
  styleUrls: ['./sz-trend-bars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzTrendBarsComponent {
  readonly bars: InputSignal<ReadonlyArray<SzTrendBar>> = input.required<ReadonlyArray<SzTrendBar>>();

  height(value: number): string {
    const clamped: number = Math.max(0, Math.min(1, value));
    return `${Math.max(6, clamped * 100)}%`;
  }
}
